// extracted by mini-css-extract-plugin
export default {"popup-overlay":"PopupDisplayer_popup-overlay__1KG0B","popup-content":"PopupDisplayer_popup-content__YstfJ"};